import { graphql } from "../gql";

export const setNewPassword = graphql(`
  mutation SetNewPassword($password: String!, $passwordConfirmation: String!, $token: String) {
    setNewPassword(input: { password: $password, passwordConfirmation: $passwordConfirmation, token: $token }) {
      error {
        message
      }
    }
  }
`);
